// API Endpoints organized by service
export const API_ENDPOINTS = {
  // Candidate Service
  candidate: {
    getAllCandidates: '/api/Candidate/GetAllCandidates',
    uploadCandidateInterviewVideo: '/api/Candidate/UploadCandidateInterviewVideo',
    getAllInterviewResultData: '/api/Candidate/GetAllInterviewResultData',
    submitInterviewFeedback: '/api/Candidate/SubmitInterviewFeedback',
  },

  // Live Interview Service
  liveInterview: {
    getSessionByUId: '/api/LiveInterview/GetSessionByUId',
    validateSessionAccess: '/api/LiveInterview/ValidateSessionAccess',
    generateToken: '/api/LiveInterview/GenerateToken',
    joinSession: '/api/LiveInterview/JoinSession',
    startSession: '/api/LiveInterview/StartSession',
    endSession: '/api/LiveInterview/EndSession',
  },

  // Interview Slot Booking Service
  interviewSlotBooking: {
    getSlotAvailability: '/api/InterviewSlotBooking/GetSlotAvailability',
    bookSelectedInterviewSlot: '/api/InterviewSlotBooking/BookSelectedInterviewSlot',
    getInterviewSlotByUId: '/api/InterviewSlotBooking/GetInterviewSlotByUId',
    getInstantInterviewByUId: '/api/InterviewSlotBooking/GetInstantInterviewByUId',
    bookInstantInterview: '/api/InterviewSlotBooking/BookInstantInterview',
  },

  // Specific Interview Management
  interview: {
    getCandidateAcsToken: '/api/Interview/GetCandidateAcsToken',
    getInterviewerAcsToken: '/api/Interview/GetInterviewerAcsToken',
    updateSessionJoined: '/api/Interview/UpdateSessionJoined',
    endSession: '/api/Interview/EndSession',
  },

  // Recording Service
  recording: {
    startRecording: '/api/Recording/StartRecording',
    uploadChunkBase64: '/api/Recording/UploadChunkBase64',
    finalizeRecording: '/api/Recording/FinalizeRecording',
  },

  // Face Detection Service
  faceDetection: {
    processImage: '/process-image/',
    detectFaces: '/detect_faces/',
    deleteFiles: '/delete-files/',
  },

  // Coding Round Service
  codingRound: {
    startTest: '/start-test',
    submitAndEvaluate: '/submit-and-evaluate',
    judge0Submissions: 'https://ce.judge0.com/submissions?base64_encoded=false&wait=true',
    judge0Languages: 'https://ce.judge0.com/languages',
  },
} as const;
